module.exports = __webpack_public_path__ + "img/full1-min.0ede4206.png";